import { Controller } from "@hotwired/stimulus"

const POLL_INTERVAL = 60000

// Periodically asks whether a fresh For You selection would be worth showing.
// The server decides and prepares it; the prompt link reuses feed-impressions#refresh.
export default class extends Controller {
    static targets = ["frame", "snapshot", "container"]
    static values = { url: String }

    initialize() {
        this.check = this.check.bind(this)
        this.clear = this.clear.bind(this)
        this.frameLoaded = this.frameLoaded.bind(this)
        this.updateVisibility = this.updateVisibility.bind(this)
    }

    connect() {
        if (document.documentElement.hasAttribute("data-turbo-preview")) return
        this.poll = setInterval(this.check, POLL_INTERVAL)
        this.frameTarget.addEventListener("turbo:frame-load", this.frameLoaded)
        this.element.addEventListener("community:feed-refresh", this.clear)
        this.element.addEventListener("community:tab-change", this.updateVisibility)
        document.addEventListener("visibilitychange", this.check)
        document.addEventListener("turbo:before-cache", this.clear)
        this.updateVisibility()
    }

    disconnect() {
        clearInterval(this.poll)
        this.frameTarget.removeEventListener("turbo:frame-load", this.frameLoaded)
        this.element.removeEventListener("community:feed-refresh", this.clear)
        this.element.removeEventListener("community:tab-change", this.updateVisibility)
        document.removeEventListener("visibilitychange", this.check)
        document.removeEventListener("turbo:before-cache", this.clear)
    }

    // Each first page of For You carries its snapshot token; a new one replaces any stale prompt.
    snapshotTargetConnected(element) {
        this.clear()
        this.token = element.dataset.token
    }

    check() {
        if (!this.token || this.shown || document.hidden || !this.onForYou() || window.scrollY < window.innerHeight) return

        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("snapshot", this.token)
        if (this.frameTarget.getAttribute("src") === url.pathname + url.search) {
            this.frameTarget.reload()
        } else {
            this.frameTarget.setAttribute("src", url.pathname + url.search)
        }
    }

    frameLoaded() {
        this.shown = this.frameTarget.querySelector("a") !== null
    }

    clear() {
        this.shown = false
        this.frameTarget.removeAttribute("src")
        this.frameTarget.replaceChildren()
    }

    updateVisibility() {
        this.containerTarget.classList.toggle("hidden", !this.onForYou())
    }

    onForYou() {
        return (this.element.dataset.activeTab || "recommended") === "recommended"
    }
}
